import { Flex, SimpleGrid } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { useTranslation } from "react-i18next";

import { TextInput } from "components";
import { CreditOptionsResponse, CreditRequestForm, CreditResponse } from "types";

import CreditRequestPersonalAddress from "./address";
import CreditRequestPersonalChildren from "./children";
import CreditRequestPersonalInfo from "./info";
import CreditRequestPersonalPartner from "./partner";

interface CreditRequestPersonalProps {
  credit: CreditResponse;
  form: UseFormReturnType<CreditRequestForm>;
  options: CreditOptionsResponse;
  visibleFields: string[];
  readOnly?: boolean;
  isBankCredit?: boolean;
}

const CreditRequestPersonal = ({
  credit,
  form,
  options,
  visibleFields,
  readOnly = false,
  isBankCredit = false,
}: CreditRequestPersonalProps) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" p="md" gap="lg">
      <CreditRequestPersonalInfo
        form={form}
        options={options}
        visibleFields={visibleFields}
        readOnly={readOnly}
      />
      <CreditRequestPersonalAddress
        form={form}
        visibleFields={visibleFields}
        readOnly={readOnly}
        isBankCredit={isBankCredit}
      />
      <CreditRequestPersonalChildren
        credit={credit}
        form={form}
        options={options}
        readOnly={readOnly}
      />
      {visibleFields.includes("partnerOnSameAddress") && (
        <CreditRequestPersonalPartner
          form={form}
          options={options}
          visibleFields={visibleFields}
          readOnly={readOnly}
          isBankCredit={isBankCredit}
        />
      )}

      <SimpleGrid cols={4} mt="lg">
        <TextInput
          label={t("credit.comment.singular")}
          key={form.key("comment2")}
          {...form.getInputProps("comment2")}
          disabled={readOnly}
        />
      </SimpleGrid>
    </Flex>
  );
};

export default CreditRequestPersonal;
